import { ReactElement } from "react";
import useGlobal from "../logic/hooks/useGlobal";


const LIST_HEIGHT = 520;

export const OverlayModal = ({
  children,
  isWhiteLabel = null,
  compact = false,
}: {
  children: ReactElement;
  isWhiteLabel?: boolean | null;
  compact?: boolean;
}) => {
  const [colorMode] = useGlobal(["colormode", "selected"]);
  const showBranding = isWhiteLabel === false;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[9999]"
      style={{
        backgroundColor: colorMode === "light" ? "rgba(8, 8, 8, 0.5)" : "rgba(10, 10, 10, 0.6)",
        backdropFilter: colorMode === "light" ? 'blur(12px)' : 'blur(5px)',
        WebkitBackdropFilter: colorMode === "light" ? 'blur(12px)' : 'blur(5px)',
      }}
    >
      <div
        style={{
          width: '520px',
          height: compact ? 'auto' : `${LIST_HEIGHT}px`,
          maxWidth: 'calc(100% - 8px)',
          maxHeight: 'calc(100% - 8px)',
          position: 'relative',
        }}
      >
        <div
          className={`w-full overflow-hidden border flex flex-col ${showBranding ? 'rounded-t-[28px] border-b-0' : 'rounded-[28px]'}`}
          style={{
            height: compact ? 'auto' : (showBranding ? 'calc(100% - 48px)' : '100%'),
            minHeight: compact ? `${showBranding ? LIST_HEIGHT - 48 : LIST_HEIGHT}px` : undefined,
            position: 'relative',
            zIndex: 100,
            backgroundColor: colorMode === 'light' ? 'rgba(255, 255, 255, 0.85)' : 'rgba(25, 25, 25, 0.7)',
            borderColor: colorMode === 'light' ? 'rgba(228, 228, 223, 0.4)' : 'rgba(255, 255, 255, 0.08)',
            backdropFilter: colorMode === 'light' ? 'blur(24px)' : 'blur(40px) saturate(1.5)',
            WebkitBackdropFilter: colorMode === 'light' ? 'blur(24px)' : 'blur(40px) saturate(1.5)',
          }}
        >
          {children}
        </div>
        {showBranding && (
          <div
            className="w-full flex items-center justify-center rounded-b-[28px] border border-t-0"
            style={{
              position: 'relative',
              zIndex: 99,
              height: '48px',
              backgroundColor: colorMode === 'light' ? 'rgba(232, 232, 228, 0.9)' : 'rgba(45, 45, 44, 0.6)',
              borderColor: colorMode === 'light' ? 'rgba(228, 228, 223, 0.4)' : 'rgba(255, 255, 255, 0.08)',
              backdropFilter: colorMode === 'light' ? 'blur(24px)' : 'blur(40px) saturate(1.5)',
              WebkitBackdropFilter: colorMode === 'light' ? 'blur(24px)' : 'blur(40px) saturate(1.5)',
            }}
          >
            <a href="https://withone.ai" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
              <div className="flex items-center gap-1.5">
                <span className="text-[11px] text-muted-foreground">
                  Secured by
                </span>
                <img
                  src={colorMode === "light" ? "/logo-full-light.svg" : "/logo-full-dark.svg"}
                  className="h-[11px]"
                  alt="One"
                />
              </div>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
